module.exports = __webpack_public_path__ + "static/media/GMA-S2100-1AER_OR01.c9fd48db.png";